class MainProductSelector extends ProductSelector {
  constructor() {
    super();

    this.stickyBarPrice = document.querySelector('[sticky-bar-price]');
  }

  onVariantChange(event) {
    super.onVariantChange(event);

    this.updateURL();
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  updatePrice() {
    super.updatePrice();

    if (this.stickyBarPrice && this.currentVariantPrice?.price_html) {
      this.stickyBarPrice.classList.remove('visually-hidden');
      this.stickyBarPrice.innerHTML = this.currentVariantPrice.price_html;
    }
  }

  setUnavailable() {
    super.setUnavailable();

    if (this.stickyBarPrice) {
      this.stickyBarPrice.classList.add('visually-hidden');
    }
  }
}

customElements.define('main-product-selector', MainProductSelector);
